import InputField from "components/fields/InputField";
import Button from "components/button/Button";
import { useNavigate } from "react-router-dom";
import React from "react";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { loginInduk } from "api/UserAPI";
import { toast } from "react-hot-toast";
import UserContext from "contexts/userContext";
import { Link } from "react-router-dom";

export default function SignIn() {
  const navigate = useNavigate();
  const { setAuthPersist } = React.useContext(UserContext);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const onSubmit: SubmitHandler<FieldValues> = (data) => {
    setIsLoading(true);

    const userCredential = { email: data?.email, password: data?.password };

    const promise = loginInduk(userCredential);

    toast.promise(promise, {
      loading: "Loading...",
      success: (res) => {
        if (res.status === 200) {
          setAuthPersist(res?.data?.data);
          navigate("/admin");
        }
        setIsLoading(false);
        return res?.data?.message || "Login berhasil!";
      },
      error: (err) => {
        setIsLoading(false);
        return err?.response?.data?.message || "Login gagal!";
      },
    });
  };

  return (
    <div className="flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <form
        className="w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]"
        onSubmit={handleSubmit(onSubmit)}
      >
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Sign In
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Enter your email and password to sign in!
        </p>
        {/* Email */}
        <InputField
          variant="auth"
          extra="mb-3"
          label="Email"
          placeholder="mail@example.com"
          id="email"
          type="email"
          register={register}
          errors={errors}
          validationSchema={{
            required: "Email harus diisi!",
            pattern: {
              value: /\S+@\S+\.\S+/,
              message: "Email tidak valid!",
            },
          }}
        />

        {/* Password */}
        <InputField
          variant="auth"
          extra="mb-3"
          label="Password"
          placeholder="Min. 8 karakter"
          id="password"
          register={register}
          errors={errors}
          validationSchema={{
            required: "Password harus diisi!",
            minLength: {
              value: 8,
              message: "Password minimal 8 karakter!",
            },
          }}
          type="password"
        />
        <Button
          extra="mt-10"
          children="Sign In"
          variant="primary"
          size="full"
          isLoading={isLoading}
        />

        <section className="mt-5 flex w-full items-center gap-1.5 text-gray-600">
          <p>Read our </p>
          <Link
            to={"/public/privacy-policy"}
            className="text-brand-500 underline"
          >
            Privacy Policy
          </Link>
        </section>
      </form>
    </div>
  );
}
